import {CheatPlugin} from '../../CheatModuleInterfaces';
import {CheatErrorsController} from './CheatErrorsController';
import {CheatErrorsView} from './CheatErrorsView';

const errors: CheatPlugin = {
    name: 'Errors pop-ups',
    init: () => [
        CheatErrorsController,
        CheatErrorsView
    ]
};

export default errors;
